import React, { useContext, useEffect, useState } from 'react'
import DetailsBox from '../../../components/Cards/DetailsBox'
import API from '../../../services/API'
import BigModal from '../../../components/Modals/BigModal'
import AddNewTask from '../../userPages/tasks/AddNewTask'
import TaskLine from '../../userPages/tasks/TaskLine'

//@MUI
import Alert from '@mui/material/Alert'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import LinearProgress from '@mui/material/LinearProgress'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import LibraryAddIcon from '@mui/icons-material/LibraryAdd'
import { Divider, Stack, Typography } from '@mui/material'
import TaskPane from '../../../components/Tasks/TaskPane'
import { EventMetaContext } from './SingleEvent'

const TasksPane = () => {
  const { eventMeta } = useContext(EventMetaContext)
  const [loading, setLoading] = useState(false)
  const [tasks, setTasks] = useState([])
  const [fetchError, setFetchError] = useState(false)
  const [openNewTask, setOpenNewTask] = useState(false)
  const [openExistingTask, setOpenExistingTask] = useState(null)

  const fetchTasks = () => {
    API.get('/tasks?relation=events&id=' + eventMeta._id)
      .then((res) =>
        res.status === 200 ? setTasks(res.data) : setFetchError(true),
      )
      .catch((e) => {
        setFetchError(true)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchTasks()
  }, [])

  const taskSuccessAction = () => {
    setOpenNewTask(false)
    fetchTasks()
  }

  return (
    <Box
      component={Paper}
      padding={2}
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid rgba(15, 23, 42, 0.08)',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)',
        bgcolor: 'background.paper',
        width: '100%'
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Stack gap={0.25}>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            Tasks
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Planner actions and follow-ups
          </Typography>
        </Stack>
        <IconButton
          size="small"
          color="primary"
          onClick={() => setOpenNewTask(true)}
        >
          <Tooltip title="Create a Task">
            <LibraryAddIcon fontSize="small" />
          </Tooltip>
        </IconButton>
      </Stack>
      {loading && <LinearProgress />}
      {tasks.length === 0 && !loading && (
        <Alert
          severity={fetchError ? 'error' : 'info'}
          color={fetchError ? 'error' : 'primary'}
        >
          {fetchError ? 'Unable to fetch tasks' : 'No Tasks Yet!'}
        </Alert>
      )}
      <Stack gap={1}>
        {tasks
          .sort((a, b) => (a.taskStatus > b.taskStatus ? 1 : -1))
          .reverse()
          .map((task) => (
            <Box
              sx={{ cursor: 'pointer' }}
              key={task._id}
              onClick={() => setOpenExistingTask(task)}
            >
              <TaskLine task={task} />
              {tasks.length > 1 && <Divider />}
            </Box>
          ))}
      </Stack>
      <BigModal
        open={openNewTask}
        onClose={() => {
          setOpenNewTask(false)
          fetchTasks()
        }}
      >
        <AddNewTask passedEvent={eventMeta} successAction={taskSuccessAction} />
      </BigModal>
      <Drawer
        open={!!openExistingTask}
        onClose={() => {
          setOpenExistingTask(false)
          fetchTasks()
        }}
        anchor="right"
      >
        <TaskPane taskID={openExistingTask?._id} />
      </Drawer>
    </Box>
  )
}

export default React.memo(TasksPane)
